import { render, staticRenderFns } from "./saleOrder.vue?vue&type=template&id=63952c56&scoped=true&"
import script from "./saleOrder.vue?vue&type=script&lang=js&"
export * from "./saleOrder.vue?vue&type=script&lang=js&"
import style0 from "./saleOrder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./saleOrder.vue?vue&type=style&index=1&id=63952c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63952c56",
  null
  
)

export default component.exports